    <div class="modal-content">
      <div class="modal-header d-block p-0">
        <div class="px-4 pt-4 pb-2">
          <div class="row">
            <div class="col-6">
              <h3 class="heading-3">{{this.data.drugButtonText}}</h3>
            </div>
            <div class="col-6 text-right">
              <span class="cursor-pointer" (click)='goback()'>
                <img src="assets/themes/icons/cancel.svg" alt="cross icon">
              </span>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-body">
        <form *ngIf="render" (ngSubmit)="onSubmit(0)" [formGroup]="drugForm" >
          <div class="bg-white row">
            <div class="form-input mb-3 col-12 col-md-6" [ngClass]="{'error': errorName ==true || errorNameValid ==true}">
              <label class="input-label">
                {{mls.languageText.drug_order_form.key2}}*
              </label>
              <input class="input-field" type="text" placeholder="{{mls.languageText.drug_order_form.key2}}" formControlName="name" (keyup)="onkey($event)"/>
              <p *ngIf="errorName ==true" class="help-text">
                {{mls.languageText.drug_order_form.key11}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key11)</span>
              </p>
              <p *ngIf="errorNameValid ==true" class="help-text">
                {{mls.languageText.drug_order_form.key19}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key19)</span>
              </p>
            </div>
            <div class="form-input mb-3 col-12 col-md-6" [ngClass]="{'error': errorMobile ==true || errorMobileValid ==true}">
              <label class="input-label">
                {{mls.languageText.drug_order_form.key3}}*
              </label>
              <input class="input-field" placeholder={{mls.languageText.drug_order_form.key3}} formControlName="mobile"
              (keyup)="onkey($event)" type="number"/>
              <p *ngIf="errorMobile ==true" class="help-text">
                {{mls.languageText.drug_order_form.key12}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key12)</span>
              </p>
              <p *ngIf="errorMobileValid ==true" class="help-text">
                {{mls.languageText.drug_order_form.key20}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key20)</span>
              </p>
            </div>
            <div class="form-input mb-3 col-12 col-md-6" [ngClass]="{'error': errorEmail ==true || errorEmailValid ==true}">
              <label class="input-label">
                {{mls.languageText.drug_order_form.key4}}*
              </label>
              <input class="input-field" type="email" placeholder={{mls.languageText.drug_order_form.key4}} formControlName="email"
              (keyup)="onkey($event)"/>
              <p *ngIf="errorEmail ==true" class="help-text">
                {{mls.languageText.drug_order_form.key13}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key13)</span>
              </p>
              <p *ngIf="errorEmailValid ==true" class="help-text">
                {{mls.languageText.drug_order_form.key21}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key21)</span>
              </p>
            </div>

            <!-- <button *ngIf="adresstemp?.address_components != undefined" (click)="updatelocation()">{{mls.languageText.drug_order_form.key5}}<span *ngIf="mls?.is_lskey_display==1">(drug_order_form.key5)</span></button> -->
            <div class="form-textarea mb-3 col-12 col-md-6" [ngClass]="{'error': errorAddress ==true || errorAddressValid ==true}">
              <label for="" class="textarea-label">
                {{mls.languageText.drug_order_form.key6}}
              </label>
              <textarea class="textarea-field" placeholder={{mls.languageText.drug_order_form.key6}} formControlName="address"
                (keyup)="onkey($event)">
              </textarea>
              <p class="help-text" *ngIf="errorAddress ==true">{{mls.languageText.drug_order_form.key14}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key14)</span>
              </p>
              <p class="help-text" *ngIf="errorAddressValid ==true">{{mls.languageText.drug_order_form.key22}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key22)</span>
              </p>
            </div>

            <div class="form-input mb-3 col-12 col-md-6" [ngClass]="{'error': errorPostcode ==true || errorPostcodeValid ==true}">
              <label class="input-label">
                {{mls.languageText.drug_order_form.key7}}*
              </label>
              <input class="input-field" placeholder={{mls.languageText.drug_order_form.key7}} formControlName="postcode"
              (keyup)="onkey($event)"/>
              <p *ngIf="errorPostcode ==true" class="help-text">
                {{mls.languageText.drug_order_form.key15}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key15)</span>
              </p>
              <p *ngIf="errorPostcodeValid ==true" class="help-text">
                {{mls.languageText.drug_order_form.key16}}<span
                *ngIf="mls?.is_lskey_display==1">(drug_order_form.key16)</span>
              </p>
            </div>

            <div class="form-input mb-3 col-12 col-md-6">
              <label class="input-label">
                {{start_date_placeholder}}*
              </label>
              <app-datepicker
                datePickerClass="input-field"
                (setDate)="setDate($event)"
                [minDate]="sminDate"
                (keyup)="onkey()"
                [maxDate]="smaxDate"
                [dateFor]="'startDate'"
                [isvalid]="isValidStartDate"
                [isDisabled]="is_disable_start_date"
                [plhldr]="start_date_placeholder"
                [errMsg]="start_date_err_msg"
                [dpPlacement]="'top'">
              </app-datepicker>
              <label class="text-danger" *ngIf="errorDate ==true">{{mls.languageText.drug_order_form.key16}}<span
                  *ngIf="mls?.is_lskey_display==1">(drug_order_form.key16)</span></label>
            </div>

            <div class="form-input mb-3 col-12 col-md-6" [ngClass]="{'error': errorTimeslot ==true}">
              <label class="input-label">{{mls.languageText.drug_order_form.key23}}*
                <span *ngIf="mls?.is_lskey_display==1">(profile_edit_certificate.key6)</span>
              </label>
              <select class="input-field input-field-height cursor-pointer" #clientValue
              (change)="changeClient($event.target.value)" (keyup)="onkey($event)">
                <option value="" disabled selected>{{mls.languageText.drug_order_form.key23}}</option>
                <option *ngFor="let ordertimeslot of timeslot" [value]="ordertimeslot?.id">
                  {{ordertimeslot?.slot_one}} - {{ordertimeslot?.slot_two}}
                </option>
              </select>
              <p class="color-error" *ngIf="errorTimeslot ==true">{{error_msg_arr[idx].year_of_received}}</p>
            </div>

          </div>
          <div *ngIf="consent && consent.is_consent" class="row">
            <div class="col-1 pr-0">
              <img width="16" [src]="'assets/themes/icons/info-icon.svg'" />
            </div>

            <div class="col-11 pl-0">
              <p class="primary-small pb-3 text-justify">{{consent.text}}</p>
            </div>
          </div>
          <div class="text-center">
            <button class="btn-design large"
              type="submit" [disabled]="drugForm.valid  != true" [ngClass]="[drugForm.valid  !=true ? 'filled-disabled': 'filled',fcs.device_detail.is_mobile ? 'w-100' : 'w-50']">
              <span *ngIf="api_in_process==true" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
              {{orderButtonText}}
            </button>
          </div>
        </form>
      </div>
    </div>
